import React from 'react'
import Footer from '../footer/Footer'
import Navbar from '../Navbar';
import cal from '../../assets/images/cal.png';
import calculator from '../../assets/images/calculator.png';
import cal2 from '../../assets/images/3.png';
import cal3 from '../../assets/images/4.png';
import cal4 from '../../assets/images/5.png';
import cal5 from '../../assets/images/6.png';
import cal6 from '../../assets/images/7.png';
import cal8 from '../../assets/images/8.png';
import backbtn from '../../assets/images/backbtn.png'
import BackupHook from './BackupHook';
import { useLocation } from 'react-router-dom';


const BookedclassDetail = () => {
    const { handleBack,handlePopup } = BackupHook()
    const location = useLocation();
    const { backupData } = location.state || {};

    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                <h1 style={{ color: 'white', fontWeight: '600' }}>Backup Class Detail</h1>
            </div>
            <div className='py-5 my-3'>
                <div className='mx-5 my-3'>
                    <img src={backbtn} onClick={handleBack} style={{ cursor: 'pointer' }} />
                </div>
                <div className='querycard'>
                    <h4 className='text-center fw '>Class 1</h4>
                    <div>
                        <div className='row mt-5'>
                            <div className='col'>
                                <div className='d-flex '
                                    style={{ borderRadius: "20px", border: "1px solid #0055FF", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Date/ Day</p>
                                        <p className=''>{backupData.data["date/day"]}</p>
                                    </div>
                                </div>

                            </div>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #A081F6", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={calculator}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Center</p>
                                        <p>{backupData.data.center}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='row my-5'>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #2BBD18", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal2}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Start Time</p>
                                        <p>{backupData.data.start_time}</p>
                                    </div>
                                </div>

                            </div>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #5AB8C3", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal3}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>End Time</p>
                                        <p>{backupData.data.end_time}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #E55577", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal4}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Skill</p>
                                        <p>{backupData.data.skill}</p>
                                    </div>
                                </div>

                            </div>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #F0B149", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal5}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Topic</p>
                                        <p>{backupData.data.topics}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row my-5'>
                            <div className='col'>
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #D146B2", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal6}></img>
                                    </div>
                                    <div>
                                        <p className='fw'>Faculty</p>
                                        <p>{backupData.data.faculty}</p>
                                    </div>
                                </div>

                            </div>
                            <div className='col'>
                                {backupData.data.zoom_link ?
                                <div className='d-flex'
                                    style={{ borderRadius: "20px", border: "1px solid #A34ECA", padding: '15px' }}
                                >
                                    <div className='me-4'>
                                        <img src={cal8}></img>
                                    </div>
                                    <div onClick={handlePopup}>
                                        <p className='fw'>Zoom Link</p>
                                        <p>{backupData.data.zoom_link}</p>
                                    </div>
                                </div>
                                :''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default BookedclassDetail
